import { logout } from './logout';
import { refreshToken } from './refreshToken';
import { getAppStore } from '../store/storeRef';
import { AppIdentifiers } from '../store/slices/token-state.slice';

const fetchWrapper = async (
  url: string,
  options: RequestInit = {},
): Promise<any> => {
  // inject Bearer token
  const token =
    getAppStore().getState().tokenState[AppIdentifiers.App]?.accessToken;
  options.headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  try {
    let response = await fetch(url, options);

    // 401 → try refresh + retry
    if (response.status === 401) {
      console.warn('Unauthorized access – trying token refresh');
      try {
        await refreshToken();
        const newToken =
          getAppStore().getState().tokenState[AppIdentifiers.App]?.accessToken;
        options.headers = {
          ...(options.headers as Record<string, string>),
          ...(newToken ? { Authorization: `Bearer ${newToken}` } : {}),
        };
        response = await fetch(url, options);
      } catch {
        console.error('Refresh failed; logging out');
        logout();
        throw new Error('Unauthorized');
      }
    }

    // server error
    if (response.status === 500) {
      console.error('Server error');
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data: any = null;
    try {
      data = await response.json();
    } catch (e) {}

    if (!response.ok) {
      const error: any = new Error(
        data?.message || response.statusText || 'Request failed',
      );
      error.status = response.status;
      error.data = data;
      throw error;
    }
    return data;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
    // swallow or rethrow depending on your UI needs
  }
};

export default fetchWrapper;
